/**
 * Add Doc to elasticLunr index
 * Created to have type checking
 *
 * @param  {any} index
 * @param  {VacatureDoc} doc
 * @returns void
 */
export function addTypesafeDoc(index: any, doc: VacatureDoc) {
  index.addDoc(doc);
}

export function removeFromArray(item: string, array: Array<string>) {
  const index = array.indexOf(item);
  if (index !== -1) {
    array.splice(index, 1);
  }
}

const mergeSearches = (querys) => querys.join(' ');

export function createQuery(
  searchQuery: string,
  index: any,
  options: any = { expand: true, boolean: 'AND' },
): Array<SearchResult> {
  // Store query in variable
  let query = '';

  // Merge alreacy active query if is set
  if (window.activeQuery.length) {
    query = mergeSearches(window.activeQuery);
  }

  // Add typed query
  if (window.typedQuery) {
    query = mergeSearches([query, window.typedQuery]);
  }

  // Search the index for query
  const results: Array<SearchResult> = index.search(query, options);

  // Return the search result
  return results;
}

/**
 * Show only the relevant vacatures,
 * based on the passed elasticlunr search results
 *
 * @param  {Array<SearchResult>} results
 * @param  {NodeListOf<HTMLElement>} vacatures
 */
export function filterResults(results: Array<SearchResult>, vacatures: NodeListOf<HTMLElement>) {
  // Define hidden class
  const hiddenClass = 'vacature-card--hidden';

  // If no results,
  if (results.length === 0) {
    // Show all vacatures
    vacatures.forEach((vacature) => {
      vacature.classList.remove(hiddenClass);
    });

    // Exit the function
    return;
  }

  // Add hidden class to all vacatures
  vacatures.forEach((vacature) => {
    vacature.classList.add(hiddenClass);
  });

  results.forEach((result) => {
    // Get resulted element
    const vacature = document.querySelector(`.vacature-card[data-id="${result.ref}"]`);

    // Remove hidden class from it
    vacature.classList.remove(hiddenClass);
  });
}
